import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import Select from './Select';

const ControlledSelect = ({ options, name, label, ...rest }) => {
    const {
        control,
        formState: { errors },
    } = useFormContext();
    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => <Select options={options} name={name} label={label} errors={errors} {...field} {...rest} />}
            // wrap
        />
    );
};

export default ControlledSelect;
